import React from 'react';
import { Link } from 'react-router-dom';
import { formatMoney } from '../../shared/formatMoney';

export default function TopCars({ items = [], loading }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm">
      <div className="flex justify-between items-center px-5 pt-4 pb-2 border-b-2 border-brand-primary">
        <h3 className="text-xs font-extrabold uppercase tracking-wider text-brand-secondary">
          Top Cars by Outstanding Balance
        </h3>
        <Link to="/cars" className="text-xs font-semibold text-brand-primary">
          View all →
        </Link>
      </div>
      <div className="px-5 py-3">
        {loading ? (
          <p className="text-xs text-gray-400 py-2">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 py-2">No outstanding car balances.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
            {items.map((car, i) => {
              const driver = car.driver_details;
              return (
                <div
                  key={car.plate_no}
                  className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-b-0"
                >
                  <div className="flex items-center gap-2 min-w-0">
                    <span className="text-[10px] text-gray-300 w-4 shrink-0 tabular-nums">{i + 1}</span>
                    <div className="min-w-0">
                      <Link
                        to={`/cars/${car.plate_no}`}
                        className="text-xs font-bold text-brand-primary hover:underline"
                      >
                        {car.plate_no}
                      </Link>
                      {driver ? (
                        <Link
                          to={`/drivers/${driver.id_no}`}
                          className="block text-[10px] text-gray-500 hover:text-brand-primary hover:underline truncate"
                        >
                          {driver.name}
                        </Link>
                      ) : (
                        (car.make || car.model) && (
                          <span className="block text-[10px] text-gray-400 truncate">
                            {[car.make, car.model].filter(Boolean).join(' ')}
                          </span>
                        )
                      )}
                    </div>
                  </div>
                  <span className="text-xs font-bold text-red-600 ml-2 shrink-0 tabular-nums">
                    {formatMoney(car.actual_bal)}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
